export default "__VITE_ASSET__Cfev1GHh__"